import { render, staticRenderFns } from "./dealRank.vue?vue&type=template&id=7872a0b5&scoped=true"
import script from "./dealRank.vue?vue&type=script&lang=js"
export * from "./dealRank.vue?vue&type=script&lang=js"
import style0 from "./dealRank.vue?vue&type=style&index=0&id=7872a0b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7872a0b5",
  null
  
)

export default component.exports